import { Icon } from 'icon/Icon'
import css from './SelectedItems.module.scss'

type Props = {
  text: string
}

export const ItemPlaceholder = ({ text }: Props) => {
  return (
    <div className={css.placeholder}>
      <div className={css.placeholderBox}>
        <Icon name="checkroom" size={16} className={css.placeholderIcon} />
      </div>
      <span className={css.placeholderText}>{text}</span>
    </div>
  )
}
